import { defineMessages } from 'react-intl-next';

export default defineMessages({
    datePickerPlaceholderNonFinal: {
        defaultMessage: 'Select a date',
        description: 'Placeholder text for the date picker field',
        id: 'virtual-agent.conversation.appendices.date-picker-placeholder-non-final',
    },
});
